import { render, staticRenderFns } from "./ShowPricing.vue?vue&type=template&id=85da4428&scoped=true"
import script from "./ShowPricing.vue?vue&type=script&lang=js"
export * from "./ShowPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85da4428",
  null
  
)

export default component.exports